/**
 * NOTE: Using a separate file from browser.js to avoid issues in electron
 * (due to accessing window on load in browser.js).
 */
export const isInIFrame = () => window.self !== window.top;
